import apiClient from "../../core/apiClient";
import { HealthCoverageAnalysis } from "../../interfaces/DTO/insurance_data/HealthCoverageAnalysis";

const API_URL = "/insurance-data";

class InsuranceAnalysisService {
  async analyzeHealthCoverage(contactId: number): Promise<HealthCoverageAnalysis> {
    const res = await apiClient.get<HealthCoverageAnalysis>(
      `${API_URL}/analyze-health-coverage?contact_id=${contactId}`
    );
    return res.data;
  }
}

export const insuranceAnalysisService = new InsuranceAnalysisService();
